import React, { useState, createContext } from 'react';

export const SelectedItemsContext = createContext();

export const SelectedItemsProvider = ({onSelect, children}) => {

  const [itemsSelected, setSelectedItems] = useState();

  function onRemovedSelectedOption(item) {
    let temp = itemsSelected.filter(f => f.value !== item.value);
    setSelectedItems(temp);

    if(onSelect) {
      onSelect(temp);
    }
  }

  function setItemsSelected(value) {
      setSelectedItems(value);
  }

  return (
    <SelectedItemsContext.Provider value={{
      itemsSelected,
      onRemovedSelectedOption,
      setItemsSelected}}>
      {children}
    </SelectedItemsContext.Provider>
  );
};